import { React, useEffect } from 'react'

import { useHistory } from 'react-router-dom'
import { AuthHeader } from 'components/ui/AuthHeader'
import { AuthItem } from 'components/ui/AuthItem'
import { AuthContent } from 'components/ui/AuthContent'
import { AuthRow } from 'components/ui/AuthRow'
import { AuthCol } from 'components/ui/AuthCol'
import ProLogin from 'components/Auth/ProLogin'
import { BaseLink } from 'components/ui/BaseLink'

import { WhyNeedAccount } from 'components/WhyNeedAccount'

import { FadeCarousel } from 'components/FadeCarousel'

import img1 from 'i/carousel_images/Influencer.png'
import img2 from 'i/carousel_images/dr-30s-scrubs.png'

const RoleSelectDev = (props) => {
  const login = true

  const history = useHistory()

  useEffect(() => {
    document.title = 'TalkPro | Login'
  }, [])

  const items = [
    { image: img1, text: 'Instant Sync with Your Calendar' },
    { image: img2, text: 'Privacy First. No Compromise' },
  ]

  return (
    <AuthRow>
      {/*<AuthCol type="gradient" />*/}
      <AuthCol>
        <FadeCarousel items={items} interval={10000} />
      </AuthCol>
      <AuthCol>
        <AuthHeader title="Login as Pro" offsetMod fadeInMode />
        {/*<AuthItem variant="divider">
          <AuthContent>
            You don’t need to remember an email and password, <br /> plus we’ll send you a
            reminders before your talk
          </AuthContent>         
        </AuthItem>*/}
        <AuthItem>
          <AuthContent>
            Everything you need is ready—organized, summarized, and simple to use from the
            moment you log in.
          </AuthContent>
        </AuthItem>
        {/*<AuthItem variant="divider">
          <Button variant="secondary" iconName="google" fullWidth>
            {login && <ProLogin />}
            Continue with Google
          </Button>
        </AuthItem>*/}
        <AuthItem>{login && <ProLogin />}</AuthItem>
        <AuthItem variant="">
          <WhyNeedAccount />
        </AuthItem>
        <AuthItem>
          <BaseLink
            cls="link1"
            href="/pro/join"
            onClick={(e) => {
              e.preventDefault()
              history.push('/pro/join')
            }}
          >
            New to Talkpro? Join here
          </BaseLink>
        </AuthItem>
      </AuthCol>
    </AuthRow>
  )
}

export default RoleSelectDev
